import { Controller } from "stimulus";

export default class extends Controller {
  declare inputTarget: HTMLInputElement;

  static get targets() {
    return ["input"];
  }

  public connect() {
    if (window.hasOwnProperty("Intl") && Intl.DateTimeFormat) {
      // https://danielcompton.net/2017/07/06/detect-user-timezone-javascript
      this.inputTarget.value = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
  }
}
